export const glassCardClass =
  "border border-white/45 bg-white/45 shadow-[0_8px_32px_rgba(0,0,0,0.2)] backdrop-blur-[15px]";

export const glassMutedCardClass =
  "border border-white/35 bg-white/30 shadow-[0_4px_20px_rgba(0,0,0,0.16)] backdrop-blur-[12px]";
